import {Component, Prop, Vue} from "vue-property-decorator";
import {Notification, NOTIFICATION_MAX_CONTENT_SIZE_IN_BYTES} from "~/modules/notifications/lib/notification";
import {fileSize} from "~/lib/helpers/formatters";

@Component
export class NotificationMaxContentSize extends Vue {

  @Prop({type: Object, required: true}) notification: Notification;

  render() {
    return this.notification.isContentSizeValid() ?
      <small>Poid maximum autorisé: {fileSize(NOTIFICATION_MAX_CONTENT_SIZE_IN_BYTES)}</small>:
      <small>Poid maximum de contenu atteint: <span>{fileSize(this.notification.getContentSize())}/{fileSize(NOTIFICATION_MAX_CONTENT_SIZE_IN_BYTES)}</span></small>
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-12ecf7ce/notification-max-content-size.tsx" });